<div class="grid-container">
    <!-- <div class="catFilterButtons">
      <mat-button-toggle-group name="catFilterButtons" #category aria-label="Category filter buttons" [formControl]="categoryFilter">
        <mat-button-toggle >All</mat-button-toggle>
        <mat-button-toggle *ngFor="let category of categories" [value]="category.Name">{{category.Name}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div> -->
    <span class="spacer"></span>
    <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="addHallOfFame()" aria-label="Add New Hall Of Fame">
            <mat-icon>add</mat-icon>
            <span>Add New Hall Of Fame</span>
        </button>
    </div>
</div>

<mat-card class="mat-elevation-z3">
    <div class="search-container">
        <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>

        <button mat-icon-button [matMenuTriggerFor]="menu" class="columnsFilter" (click)="$event.stopPropagation()" matTooltip="Show/Hide Columns">
            <mat-icon>filter_list</mat-icon>
        </button>

        <mat-menu #menu="matMenu" xPosition="before">
            <mat-selection-list
                #columnFilter
                (click)="$event.stopPropagation()"
                [(ngModel)]="columnsToDisplay"
            >
                <mat-list-option [class.hidden]="columnChoices" value="actions" selected>
                    actions
                </mat-list-option>
                <mat-list-option *ngFor="let column of columnChoices" [value]="column">
                    {{ column }}
                </mat-list-option>
            </mat-selection-list>
        </mat-menu>
    </div>

    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="width: 125px"></th>
                <td mat-cell *matCellDef="let hallOfFame">
                    <button mat-flat-button color="primary" (click)="editHallOfFame(hallOfFame)">Edit</button>
                    <button mat-flat-button color="warn" (click)="deleteHallOfFame(hallOfFame)">Delete</button>
                </td>
            </ng-container>

            <!-- Categories Column -->
            <ng-container matColumnDef="Categories">
                <th mat-header-cell *matHeaderCellDef style="width: 200px">Categories</th>
                <td mat-cell *matCellDef="let hallOfFame">
                    <app-category-tags
                        [itemCategories]="hallOfFame.hofcategoryHallOfFame"
                        [items]="hallOfFames"
                        [itemName]="hallOfFame.Name"
                        [itemId]="hallOfFame.hallOfFameId"
                        [categories]="categories"
                        [categoryNames]="categoryNames"
                        categoryType="hof"
                        key="Name"
                        localStorageKey="hallOfFames"
                    >
                    </app-category-tags>
                </td>
            </ng-container>

            <!-- id Column -->
            <ng-container matColumnDef="Id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.hallOfFameId }}</td>
            </ng-container>

            <!-- Prefix Column -->
            <ng-container matColumnDef="Prefix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Prefix</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.prefix }}</td>
            </ng-container>

            <!-- First Column -->
            <ng-container matColumnDef="First">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.firstName }}</td>
            </ng-container>

            <!-- Middle Column -->
            <ng-container matColumnDef="Middle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Middle</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.middleName }}</td>
            </ng-container>

            <!-- Nickname Column -->
            <ng-container matColumnDef="Nickname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nickname</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.nickname }}</td>
            </ng-container>

            <!-- Last Column -->
            <ng-container matColumnDef="Last">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.lastName }}</td>
            </ng-container>

            <!-- Suffix Column -->
            <ng-container matColumnDef="Suffix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Suffix</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.suffix }}</td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="Title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.title }}</td>
            </ng-container>

            <!-- Inducted Column -->
            <ng-container matColumnDef="Inducted">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Inducted</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.inducted }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.status }}</td>
            </ng-container>

            <!-- School Column -->
            <ng-container matColumnDef="School">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>School</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.school }}</td>
            </ng-container>

            <!-- Year Column -->
            <ng-container matColumnDef="Year">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.year }}</td>
            </ng-container>

            <!-- Bio Column -->
            <ng-container matColumnDef="Bio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Bio</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.bio }}</td>
            </ng-container>

            <!-- PhotoUrl Column -->
            <ng-container matColumnDef="PhotoUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Photo Url</th>
                <td mat-cell *matCellDef="let hallOfFame">{{ hallOfFame.photoUrl }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let event; columns: columnsToDisplay; let even = even" [class.evenRow]="even" class="event-row"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="2">
                    No hall of fame members matching the filter
                    <span *ngIf="search.value"> "{{ search.value }}"</span>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
</mat-card>
